import { WorkflowConfigParser } from '@refly-packages/ai-workspace-common/components/canvas';

const TestPage = () => {
  const handleConfigParsed = (config: {
    title: string;
    tasks: any[];
    variables: any[];
  }) => {
    console.log('解析后的工作流配置:', config);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <h1 className="text-2xl font-bold mb-6">工作流配置解析器测试</h1>
      <WorkflowConfigParser onConfigParsed={handleConfigParsed} />
    </div>
  );
};

export default TestPage;